import React from 'react';
import { Box, IconButton } from '@material-ui/core';
import { ArrowBack } from '@material-ui/icons';
import { useTranslation } from 'react-i18next';
import DescriptionIcon from '@material-ui/icons/Description';
import { DeliveryListQuery } from '../../../../generated/graphql';
import {
    Card,
    ColoredTwoLineCard,
    DeliveryListIcon,
    HighlightedInfoItemWrapper,
    HighlightedInfoWrapper,
    LargeDateInfo,
    LargeInfo,
} from '../../../../ui-kit';
import { useUser } from '../../../../utils/hooks/auth';
import { useDateTimeService } from '../../../../utils/hooks/dateTimeService';
import { usePriceService } from '../../../../utils/hooks/priceService';
import DeliveryListTable from './DeliveryListTable';

interface DeliveryListDetailsViewProps {
    deliveryList: DeliveryListQuery['deliveryList'];
    onClose(): void;
}

const DeliveryListDetailsView = ({ deliveryList, onClose }: DeliveryListDetailsViewProps) => {
    const { user: { cultureCode, defaultCurrency: { currencyCode } } } = useUser();
    const { dateTimeService } = useDateTimeService();
    const { priceService } = usePriceService();
    const { t } = useTranslation();

    const {
        supplier,
        deliveryDateUtc,
        deliveryListItems,
        deliveryListItemsCount,
        deliveryListItemsTotalCost,
        invoiceNumber,
    } = deliveryList;
    const localizedDate = dateTimeService.localizeDate(deliveryDateUtc, cultureCode);
    const localizedTotal = priceService.toLocaleString(deliveryListItemsTotalCost, currencyCode);

    return (
        <Card style={{ height: '100%', overflow: 'auto' }}>
            <Box px={3} py={2}>
                <IconButton edge="start" color="inherit" onClick={onClose} aria-label="close">
                    <ArrowBack />
                </IconButton>
                <Box mb={2} />
                <HighlightedInfoWrapper>
                    <HighlightedInfoItemWrapper>
                        <LargeDateInfo label={t('Delivery date')} text={localizedDate} />
                    </HighlightedInfoItemWrapper>
                    <HighlightedInfoItemWrapper>
                        <LargeInfo Icon={DescriptionIcon} label={t('Invoice number')} text={invoiceNumber || t('Not specified')} />
                    </HighlightedInfoItemWrapper>
                    <HighlightedInfoItemWrapper>
                        <LargeInfo Icon={DeliveryListIcon} label={t('Supplier')} text={supplier.legalName} />
                    </HighlightedInfoItemWrapper>
                </HighlightedInfoWrapper>
                <HighlightedInfoWrapper>
                    <HighlightedInfoItemWrapper>
                        <ColoredTwoLineCard label={t('Total cost')} value={localizedTotal} variant="primary" />
                    </HighlightedInfoItemWrapper>
                    <HighlightedInfoItemWrapper>
                        <ColoredTwoLineCard label={t('Items count')} value={deliveryListItemsCount} variant="primary" />
                    </HighlightedInfoItemWrapper>
                </HighlightedInfoWrapper>
            </Box>
            <DeliveryListTable deliveryListItems={deliveryListItems} />
        </Card>
    );
};

export default DeliveryListDetailsView;
